import styles from './PressReleaseCard.module.scss'
import cn from 'classnames'
import Link from 'next/link'
import useFormatDate from '@/hooks/useFormatDate'
import renderCustomIcon from '@/utils/renderCustomIcon'

function PressReleaseCard({ data, className, ...props }) {
  const DownloadIcon = renderCustomIcon('download')
  const date = useFormatDate({ date: data.date, day: 'numeric', month: 'long', year: 'numeric' })

  return (
    <Link
      href={data.downloadAcf.file.mediaItemUrl}
      download
      target="_blank"
      rel="noreferrer"
      className={cn(styles['root'], { [className]: className })}
      {...props}
    >
      <DownloadIcon />

      <div>
        <p>{data.title}</p>

        <time>{date}</time>
      </div>
    </Link>
  )
}

export default PressReleaseCard
